'use client'
import { Button } from '@/components/ui/button'

export default function ResultsGroupingControls({
  splitMode,
  classMode,
  onSplitChange,
  onClassChange,
  showSplits,
  showClasses,
  disabled = false,
}) {
  if (!showSplits && !showClasses) return null
  return (
    <div className="flex flex-wrap gap-5">
      {[
        {
          label: 'Splits',
          show: showSplits,
          mode: splitMode,
          onChange: onSplitChange,
          separate: 'By Split',
        },
        {
          label: 'Classes',
          show: showClasses,
          mode: classMode,
          onChange: onClassChange,
          separate: 'By Class',
        },
      ]
        .filter((control) => control.show)
        .map((control) => (
          <div
            key={control.label}
            role="group"
            aria-label={control.label}
            className="flex flex-col gap-2"
          >
            <span className="text-xs font-semibold uppercase text-neutral-blue-400">
              {control.label}
            </span>
            <div className="flex gap-2">
              <Button
                type="button"
                variant={control.mode === 'split' ? 'default' : 'outline'}
                aria-pressed={control.mode === 'split'}
                onClick={() => control.onChange('split')}
              >
                {control.separate}
              </Button>
              <Button
                type="button"
                aria-label={'Combined ' + control.label.toLowerCase()}
                disabled={disabled}
                variant={control.mode === 'overall' ? 'default' : 'outline'}
                aria-pressed={control.mode === 'overall'}
                onClick={() => control.onChange('overall')}
              >
                Combined
              </Button>
            </div>
          </div>
        ))}
    </div>
  )
}
